import { ImageSizeTypes } from '@codeparva/ui-components-library/dist/components/element/props/ElementTypes';
import { HTMLAttributes } from 'react';
import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';
import { IconTypes } from '../../../../utilities/icomoon-css/iconTypes';
import React from 'react';

export namespace UnitAvailabilityTypes {
  export type TAmenitiesList = {
    amenity_text: string;
    amenity_icon: IconTypes.TName;
  };
  export type TUnitTypesRes = {
    amenitiesList: TAmenitiesList[];
    customArt: any;
    fee: TFee;
    overbookedcount: number;
    tfw: TTFW;
    unitTypeCategory: string;
    unitTypeID: string;
    unitTypeName: string;
    unitTypeRate: TRate;
    unitTypeStatus: string;
    unitdimensions: TDimensions;
    vacantUnitsCount: {
      total_count: number;
    };
  };
  export interface TTotalCountAndTFW {
    totalCount: number;
    isReservationOrMoveInEnabled: boolean;
  }
  type TCTAButtonsConfig = {
    callToAction: CTAButtonTypes.TCallToAction;
  };

  export type TImageAttributes = {
    alternativeText: string;
    caption: string;
    createdAt: string;
    ext: string;
    formats: TFormats;
    hash: string;
    height: number;
    mime: string;
    name: string;
    previewUrl: string;
    provider: string;
    provider_metadata: string;
    size: number;
    updatedAt: string;
    url: string;
    width: 216;
  };

  type TImageData = {
    attributes: TImageAttributes;
  };

  type TImage = {
    alternativeText: string;
    caption: string;
    url: string;
    formats: TFormats;
  };
  type TFormats = {
    ext: string;
    url: string;
    hash: string;
    mime: string;
    name: string;
    path: null;
    size: number;
    width: number;
    height: number;
  };
  export type TAttributes = {
    name: string;
    alternativeText: string;
    caption: string;
    width: number;
    height: number;
    formats: {
      small: TFormats;
      xsmall: TFormats;
      thumbnail: TFormats;
    };
    hash: string;
    ext: string;
    mime: string;
    size: number;
    url: string;
    previewUrl: null;
    provider: string;
    provider_metadata: null;
    createdAt: string;
    updatedAt: string;
  };
  type TCustomArtSingleImage = {
    data: {
      id: number;
      attributes: TAttributes;
    };
  };
  type TCustomArt = {
    show: boolean;
    image?: TImage;
    imageUrl?: string;
    maxSize?: ImageSizeTypes;
    unit_type_description_title?: string;
    unit_type_description_description?: string;
    custom_art_single_image?: TCustomArtSingleImage;
    __v?: number;
  };

  type TDefaultImage = {
    data: TImageData;
  };

  export type TUnitTypeData = {
    defaultName?: string;
    category?: string;
    aliasName?: string;
    size?: 'small' | 'medium' | 'large';
    amenitiesList?: TAmenitiesList[];
    rate?: number;
    currencyCode?: string;
    onlineOffer?: string | number;
    callToActionButtons: TCTAButtonsConfig[];
    customArt: TCustomArt;
  };
  export type TAmenityList = {
    amenity: TAmenitiesList;
  };
  export type TModalTypes = {
    showModal: boolean;
    data: UnitAvailabilityTypes.TData;
    unitTypeName?: string;
    showModalImg: React.MouseEventHandler<HTMLButtonElement>;
    transformedGatsbyImageData: TGatsbyImage;
  };
  export type TAlertModalTypes = {
    alertModalInfo: TAlertModalInfo;
    setAlertModalInfo: React.Dispatch<React.SetStateAction<any>>;
    logOutHandler: () => void;
    locationStrapiId: string;
    facilityName: string;
    facilityIdDetails: TFacilityIdDetails;
    selectedLocation: any;
    unitsData: any;
  };
  export type TAlertModalInfo = {
    showModal: boolean;
    currentUnitTypeData: any;
    type: string;
  };
  export type TIndividualData = {
    element: TUnitTypeData;
  };
  export type TTitle = {
    show: boolean;
    showOnMobile: boolean;
    name: string;
  };

  type TDefaultUnitImage = {
    default_image: TDefaultImage;
  };
  export type TVariantType = 'horizontal' | 'vertical' | 'default';
  export type TUnitAvailabilityConfig = {
    variant: TVariantType;
    strapi_facilityID?: number;
    facilityId?: string;
    theme: TTheme;
    title: TTitle;
    unitTypeData: TUnitTypeData[];
    defaultUnitImage: TDefaultUnitImage[];
    customArtGatsby?: any;
    defaultGatsbyImage?: any;
  };
  export type THorizontalVerticalConfig = {
    url: string;
    thumbImgUrl: string;
    ImgUrl: string;
    currencyCodes: {
      USD: string;
      EUR: string;
      GBP: string;
      INR: string;
    };
    categories: {
      No_Category: string;
      No_CategoryIcon: string;
      Climate_Controlled: string;
      Climate_ControlledIcon: string;
      Mobile: string;
      MobileIcon: string;
      Outdoor_Parking: string;
      Outdoor_ParkingIcon: string;
    };
    unitTypeArrayLength: number;
  };
  export type TFee = {
    setup: string;
    deposit: string;
  };
  export type TRate = {
    Month: string;
    Annual?: string;
    Seasonal?: string;
    Week?: string;
    Day: string;
    Quarter?: string;
    Bi_Annual?: string;
    Twenty_Eight_Day?: string;
  };
  export type TMoveIn = {
    is_enabled: boolean;
    web_rate: number;
    group: string;
  };
  export type TReservation = {
    is_enabled: boolean;
    web_rate: number;
  };
  export type TTFW = {
    reservation: TReservation;
    description: string;
    move_in: TMoveIn;
  };
  export type TDimensions = {
    width: number;
    depth: number;
  };
  export type TData = {
    amenitiesList: TAmenitiesList[];
    fee: TFee;
    unitTypeCategory: string;
    unitTypeName: string;
    unitTypeRate: TRate;
    unitTypeStatus: string;
    aliasName: string;
    category: string;
    customArt?: any;
    defaultName: string;
    id: string;
    rate: string;
    currencyCode: string;
    size: 'small' | 'medium' | 'large';
    callToActionButtons: TCTAButtonsConfig[];
    priceText: string;
    tfw: TTFW;
    unitTypeID: string;
    vacantUnitsCount: {
      total_count: number;
    };
    unitdimensions: TDimensions;
    isPaymentEnabled: boolean;
    overbookedcount: number;
    reservedUnitsCount: any;
  };
  export type TViewRatesAmenitiesCTA = {
    index: number;
    viewCTAStatus: boolean;
    setViewCTAStatus: React.Dispatch<React.SetStateAction<boolean>>;
  };
  export type TFacilityIdDetails = {
    selectedFacilityId: string;
    loggedInFacilityId: string;
  };
  export type TVerticalTypeData = {
    data: TData;
    UnitAvailabilityConfig: TUnitAvailabilityConfig;
    theme: 'dark' | 'light';
    onSetIndividualData: React.Dispatch<React.SetStateAction<any>>;
    WhatWeOfferConfig: any;
    index: number;
    transformedGatsbyImageData: TGatsbyImage;
    facilityIdDetails: TFacilityIdDetails;
  };
  export type GenericCTAConfig = {
    UnitAvailabilityConfig: TUnitAvailabilityConfig;
    data: TData;
    onSetIndividualData: React.Dispatch<React.SetStateAction<TData>>;
    facilityIdDetails: TFacilityIdDetails;
  };
  export type UnitTypesTablet = {
    showModal: boolean;
    data: TData;
    unitTypeName: string;
    showModalImg: () => void;
    UnitAvailabilityConfig: TUnitAvailabilityConfig;
    onSetIndividualData: React.Dispatch<React.SetStateAction<any>>;
  };
  export type TUnitTypes = {
    id: string;
    title: string;
    unitTypeData: TData[];
  };
  export type TLocationPage = {
    id: string;
    jumbotron?: any;
    unittypes: TUnitTypes;
  };
  type TGatsbyImage = {
    alt: any;
    height: any;
    width: any;
    sourceProps: any;
    placeholder: any;
    imgProps: {
      src: any;
    };
  };
  export type TUnitAvailabilityRes = {
    data: TData;
    facilityDetails?: {
      locationPage: TLocationPage[];
    };
    UnitAvailabilityConfig: TUnitAvailabilityConfig;
    onSetIndividualData: React.Dispatch<React.SetStateAction<any>>;
    WhatWeOfferConfig: any;
    index: number;
    img?:
      | UnitAvailabilityTypes.TAttributes
      | UnitAvailabilityTypes.TImageAttributes
      | undefined;
    transformedGatsbyImageData: TGatsbyImage;
    facilityIdDetails: TFacilityIdDetails;
  };
  export type TTheme = 'light' | 'dark';

  export interface IUnitAvailabilty extends HTMLAttributes<HTMLDivElement> {
    customArtGatsby?: any;
    defaultGatsbyImage?: any;
    res: TUnitAvailabilityRes[] | any;
    UnitAvailabilityConfig: TUnitAvailabilityConfig;
    onSetIndividualData: React.Dispatch<React.SetStateAction<any>> | any;
    WhatWeOfferConfig: any;
    locationStrapiId?: any;
    facilityName?: any;
    showVacantUnit?: boolean;
    facilityIdDetails: TFacilityIdDetails;
    logOutHandler: () => void;
    globalContext: any;
    selectedLocation: any;
  }

  export type TFilterObject = {
    type: string;
    name: string;
    value: string;
  };

  export type TViewRatesFilter = {
    unitsFilter: TFilterObject[];
    activeFilters: TFilterObject[];
    activeFilterStateHandler: React.Dispatch<
      React.SetStateAction<TFilterObject[]>
    >;
  };

  export type TRenderCheckboxSection = {
    heightForTop: number;
    typeFilter: string;
    unitsFilter: TFilterObject[];
    activeFilters: TFilterObject[];
    activeFilterStateHandler: React.Dispatch<
      React.SetStateAction<TFilterObject[]>
    >;
  };

  export type TRenderSmallScreenCheckboxSection = {
    heightForTop: number;
    typeFilter: string;
    unitsFilter: TFilterObject[];
    activeFilters: TFilterObject[];
    onChangeHandler: any;
  };

  export type TAmenitiesFilter = {
    amenity_icon: IconTypes.TName;
    amenity_text: string;
  };

  export type TAddFilterToList = (
    inputFilter: TFilterObject,
    activeFilters: TFilterObject[],
    allFilters: any,
    updateActiveFilter: React.Dispatch<React.SetStateAction<TFilterObject[]>>
  ) => void;
  export type TRemoveFilterFromList = (
    inputFilter: TFilterObject,
    activeFilters: TFilterObject[],
    updateActiveFilter: React.Dispatch<React.SetStateAction<TFilterObject[]>>
  ) => void;
  export type TViewRatesFilterModal = {
    openResponsiveFilterHandler: () => void;
    amenitiesTypeFilterDivHeight: number;
    unitsTypeFilterDivHeight: number;
    unitsFilter: TFilterObject[];
    activeFilters: TFilterObject[];
    activeFilterStateHandler: React.Dispatch<
      React.SetStateAction<TFilterObject[]>
    >;
  };
  export type TViewRatesSmallScreenSubSection = {
    filterType: string;
    currStatus: boolean;
    heightFromTop: number;
    typeFilter: string;
    sectionText: string;
    changeFilterDropDownStatus: any;
    smallScreenActiveFilter: any;
    unitsFilter: any;
    smallScreenFilterHandler: any;
  };
  export type TReusableFilterSection = {
    filterType: string;
    currentStatus: boolean;
    heightForTop: number;
    divRef: any;
    filterRef: any;
    activeFilters: TFilterObject[];
    activeFilterStateHandler: React.Dispatch<
      React.SetStateAction<TFilterObject[]>
    >;
    unitsFilter: TFilterObject[];
    changeFilterDropDownStatus: (filterType: string) => void;
  };
}
